import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Vintersakrat = lazy(() => import("@/pages/elavtal/Vintersakrat"));

export const Route = createFileRoute("/elavtal/vintersakrat")({
  head: () => seoHead("/elavtal/vintersakrat", { description: "Ett vintersäkrat avtal låser priset under de dyraste månaderna november–mars, men låter dig dra nytta av månadspris resten av året." }),
  component: () => <Vintersakrat />,
});
